import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  Avatar,
  Divider,
  Button,
} from "@mui/material";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  selectUser,
  loginSelector,
  authSelector,
} from "../../redux/selectors/user.selector";
import { blue, green, pink, purple, red, teal } from "@mui/material/colors";
import ReusableDialog from "../common/dialog";
import { useDispatch } from "react-redux";
import { cancelSubscription } from "../../redux/thunk/user";
import { useTheme } from "@emotion/react";
import QRCode from "react-qr-code";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { asyncUserDashboardData } from "../../redux/thunk/user";

const UserDashboard = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const auth = useSelector(authSelector);
  const isLoggedIn = useSelector(loginSelector);
  const dispatch = useDispatch();
  const [openCancelSubsDialog, setOpenCancelSubsDialog] = useState(false);
  const [color, setColor] = useState();

  const {
    name,
    email,
    trialActivated,
    daysLeftInTrial,
    phoneNumber,
    subscriptionActivated,
    profilePicture,
  } = user;

  const getRandomColor = () => {
    const colors = [blue, green, pink, purple, red, teal];
    const randomIndex = Math.floor(Math.random() * colors.length);
    const randomColor = colors[randomIndex][300];
    return randomColor;
  };

  useEffect(() => {
    const randomColor = getRandomColor();
    setColor(randomColor);
    const accessToken = auth.access_token;
    dispatch(asyncUserDashboardData(email, accessToken));
  }, []);

  const handleCancelSubscriptionConfirmation = () => {
    setOpenCancelSubsDialog(false);
    dispatch(cancelSubscription(user.email));
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  return (
    <>
      <ReusableDialog
        title="Info"
        open={openCancelSubsDialog}
        onClose={() => setOpenCancelSubsDialog(false)}
        text="Are you sure you want to cancel your subscription? This action is not reversible."
        showSecondButton={true}
        mainButtonText="Cancel Subscription"
        handleMainButtonClick={handleCancelSubscriptionConfirmation}
        error={true}
      />
      {isLoggedIn ? (
        <Paper
          elevation={3}
          style={{
            padding: "20px",
            maxWidth: "600px",
            margin: "auto",
            marginTop: "50px",
          }}
        >
          <Typography variant="h5" align="center" gutterBottom>
            <div style={{ display: "flex", alignItems: "center" }}>
              Account Dashboard
              <Button
                variant="outlined"
                onClick={handleLogout}
                style={{ marginLeft: "auto" }}
              >
                Logout
              </Button>
            </div>
          </Typography>
          <Divider style={{ marginBottom: "20px" }} />
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Avatar
                style={{
                  backgroundColor: color,
                  width: "120px",
                  height: "120px",
                }}
              >
                {profilePicture ? (
                  <img src={profilePicture} alt="profile" />
                ) : (
                  name && name[0].toUpperCase()
                )}
              </Avatar>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h6">{name}</Typography>
              <Typography variant="body2" color="textSecondary">
                {email}
              </Typography>
            </Grid>
          </Grid>
          <Divider style={{ margin: "20px 0" }} />
          <Box>
            <Typography variant="subtitle1">
              <strong>
                {trialActivated ? "Active Trial:" : "Active Subscription:"}
              </strong>{" "}
              {subscriptionActivated || trialActivated ? "Yes" : "No"}
            </Typography>

            {(trialActivated || subscriptionActivated) && (
              <Typography variant="subtitle1">
                <strong>Days Left in Plan Expiration:</strong> {daysLeftInTrial}
              </Typography>
            )}
            {(trialActivated && daysLeftInTrial === 0) ||
              ((!trialActivated || !subscriptionActivated) && (
                <Typography>
                  Renew Plan{" "}
                  <Link
                    to="/pricing"
                    style={{ color: `${theme.palette.primary.main}` }}
                  >
                    Pricing
                  </Link>
                </Typography>
              ))}
            {subscriptionActivated && (
              <Button
                variant="outlined"
                onClick={() => setOpenCancelSubsDialog(true)}
                style={{ marginTop: "20px" }}
              >
                Cancel Subscription
              </Button>
            )}
            <Box
              style={{
                marginTop: "20px",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Start with ACC Copilot
              </Typography>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Box
                  style={{
                    padding: "10px",
                    borderRadius: "5px",
                    backgroundColor: "white",
                    margin: "0 20px 0 0",
                  }}
                >
                  <QRCode
                    value={`https://wa.me/+12706334625?text=Hello`}
                    size={120}
                  />
                </Box>
                <Typography variant="subtitle1" style={{ marginRight: "20px" }}>
                  or
                </Typography>
                <Button
                  variant="contained"
                  startIcon={<WhatsAppIcon />}
                  style={{ backgroundColor: green[500], color: "white" }}
                  component="a"
                  href={`https://wa.me/+12706334625?text=Hello`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open WhatsApp
                </Button>
              </div>
            </Box>
          </Box>
        </Paper>
      ) : (
        <>
          <Divider />
          <Typography variant="h5" style={{ padding: "20px" }}>
            Login or Sign-up to access User Dashboard
          </Typography>
        </>
      )}
    </>
  );
};

export default UserDashboard;
